import React from "react";
import {
  ProgressRingContainer,
  ProgressRingCircle,
  ProgressRingText,
} from "../styles";

const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

const ProgressRing = ({ value }) => {
  const v = clamp(value, 0, 100);
  const r = 18;
  const c = 2 * Math.PI * r;
  const dash = (v / 100) * c;

  return (
    <ProgressRingContainer width="48" height="48" viewBox="0 0 48 48">
      <circle
        cx="24"
        cy="24"
        r={r}
        stroke="rgba(255,255,255,.12)"
        strokeWidth="5"
        fill="none"
      />
      <circle
        cx="24"
        cy="24"
        r={r}
        stroke="rgba(92,233,255,.95)"
        strokeWidth="5"
        fill="none"
        strokeDasharray={`${dash} ${c - dash}`}
        strokeLinecap="round"
        transform="rotate(-90 24 24)"
      />
      <ProgressRingText x="24" y="28">
        {v}
      </ProgressRingText>
    </ProgressRingContainer>
  );
};

export default ProgressRing;
